export const defaultSidebarMenuConfig = [
    {
        label: "Management",
        items: [
            {
                menuKey: "dashboard",
                menuTitle: "Dashboard",
                menuIcon: "lucide:layout-dashboard",
                navigationPath: "/dashboard",
            },
        ],
    },
    {
        label: "Shift Management",
        items: [
            {
                menuKey: "shiftManagement",
                menuTitle: "Shifts Management",
                menuIcon: "fluent:shifts-team-20-regular",
                children: [
                    {
                        menuKey: "shiftSetup",
                        subMenuName: "Shift Setup",
                        navigationPath: "/shift-setup",
                    },
                    {
                        menuKey: "shiftAssignment",
                        subMenuName: "Shift Assignment",
                        navigationPath: "/shift-assignment",
                    },
                    {
                        menuKey: "shiftScheduling",
                        subMenuName: "Shift Schedule",
                        navigationPath: "/shift-scheduling",
                    }
                ],
            },
        ],
    },
    {
        label: "Attendance Management",
        items: [
            {
                menuKey: "attendanceManagement",
                menuTitle: "Attendance Management",
                menuIcon: "lucide:clock",
                children: [
                    {
                        menuKey: "attendanceRecord",
                        subMenuName: "Attendance Record",
                        navigationPath: "/attendance-record",
                    },
                    {
                        menuKey: "attendanceReports",
                        subMenuName: "Attendance Reports",
                        navigationPath: "/attendance-reports",
                    },
                    {
                        menuKey: "departmentAttendance",
                        subMenuName: "Department Attendance",
                        navigationPath: "/department-attendance",
                    },
                    {
                        menuKey: "leaveApproval",
                        subMenuName: "Leave Approval",
                        navigationPath: "/leave-approval",
                    },
                ],
            },
        ],
    },
    {
        label: "Leave & Holiday Management",
        items: [
            {
                menuKey: "leaveManagement",
                menuTitle: "Faculty Leave Management",
                menuIcon: "lucide:plane-takeoff",
                children: [
                    {
                        menuKey: "holidayCalendar",
                        subMenuName: "Academic Holiday Calendar",
                        navigationPath: "/leave-management/holiday-calendar",
                    },
                    {
                        menuKey: "leaveConfiguration",
                        subMenuName: "Leave Policy Configuration",
                        navigationPath: "/leave-management/leave-configuration",
                    },
                    {
                        menuKey: "leaveRequests",
                        subMenuName: "Faculty Leave Requests",
                        navigationPath: "/leave-management/leave-requests",
                    },
                    {
                        menuKey: "leaveAllocation",
                        subMenuName: "Faculty Leave Allocation",
                        navigationPath: "/leave-management/leave-allocation",
                    },
                    {
                        menuKey: "departmentLeaveReport",
                        subMenuName: "Department Leave Report",
                        navigationPath: "/leave-management/department-leave-report",
                    }
                ],
            },
        ]
    },
    {
        label: "Institute Settings",
        items: [
            {
                menuKey: "instituteLocation",
                menuTitle: "Institute Location Management",
                menuIcon: "lucide:map-pin",
                navigationPath: "/institute-location",
            },
        ],
    },
    {
        label: "Staff Management",
        items: [
            {
                menuKey: "staffManagement",
                menuTitle: "Staff Management",
                menuIcon: "lucide:user-check",
                children: [
                    {
                        menuKey: "staffLeaveConfiguration",
                        subMenuName: "Leave Configuration",
                        navigationPath: "/staff-management/leave-configuration",
                    },
                    {
                        menuKey: "leaveHistory",
                        subMenuName: "Leave History",
                        navigationPath: "/staff-management/leave-history",
                    },
                    {
                        menuKey: "attendanceHistory",
                        subMenuName: "Attendance History",
                        navigationPath: "/staff-management/attendance-history",
                    },
                    // {
                    //     menuKey: "staffAttendance",
                    //     subMenuName: "Staff Attendance",
                    //     navigationPath: "/staff-management/staff-attendance",
                    // },
                    {
                        menuKey: "shiftSchedule",
                        subMenuName: "My Shift Scheduling",
                        navigationPath: "/staff-management/shift-schedule",
                    },
                ],
            },
        ],
    },
];
